import React from "react";
import geymerlarData from './MenuData/GeymerlarData';

function Geymerlar() {
  return (
    <div className="mx-auto w-full overflow-y-scroll h-[600px] p-2">
      <div className="grid p-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 justify-evenly gap-8">
        {geymerlarData.map((item, index) => (
          <div key={index} className="flex flex-col text-left text-xl">
            <a
              href="#"
              className="text-textBlack mb-3 text-xl sm:text-base md:text-lg lg:text-xl xl:text-xl font-medium hover:text-blueColor transition duration-200"
            >
              {item.title}
            </a>
            <a
              href="#"
              className="text-grayColor mb-2 text-base sm:text-sm md:text-sm lg:text-base xl:text-base font-body hover:text-blueColor transition duration-200"
            >
              {item.link}
            </a>

            {/* Options */}

            {item.options &&
              Object.keys(item.options).map((optionKey, optionIndex) => (
                <a
                  key={optionIndex}
                  href={`#${optionKey}`} // Use the optionKey as the href value
                  className="text-grayColor mb-2 text-base sm:text-sm md:text-sm lg:text-base xl:text-base font-body hover:text-blueColor transition duration-200"
                >
                  {item.options[optionKey]}                  
                </a>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Geymerlar;
